export default __webpack_public_path__ + "static/media/Halloween2.5950afc9.png";